export default function needReset(urlKey) {
  const regEx = /^((https?:\/\/)?(dev\.)?steelline(-doors)?\.(by|ru))?\/(mezhkomnatnye-|vhodnye-)dveri.*/;

  return regEx.test(urlKey);
}